import {Component_Create} from "./component-create";
import {InterchangeableComponentGroupNl} from "./interchangeable-component-group-nl";
import {InterchangeableComponentHttpService} from "../_services/interchangeable-component-http.service";
import {App} from "../../../app-injector";

/**
 * Create/update payload for an interchangeable component group. Deliberately carries no `name` (#372):
 * the group is one-time-use — rebuilt from scratch on every composition save, never looked up by name —
 * so a name has nowhere to be an identity, only a label. The server used to accept a `name` on the wire
 * and silently discard it (never assigned it to the resulting entity); that is the defect this fixes.
 * Do not reintroduce `name` here without a real reuse/lookup use case behind it.
 */
export class InterchangeableComponentGroup_Create {
  id: string = "";

  components: Component_Create[] = [];

  static from(group: InterchangeableComponentGroupNl | undefined): InterchangeableComponentGroup_Create | undefined {
    if (!group) return undefined;

    const s = App.Injector.get(InterchangeableComponentHttpService);
    let model = new InterchangeableComponentGroup_Create();
    model.id = group.id;

    // get interchangeable components from server
    s.list(group.interchangeableComponents)
      .withLoadingIndicator()
      .subscribe({
        next: components => {
          model.components = components
            .map(c => Component_Create.from(c));
        }
      })

    return model;
  }
}
